export const NEW_PRODUCT_PLACEHOLDER = '#';
export const MIN_COUNT_OF_PRODUCTS = 1;
export const MAX_COUNT_OF_PRODUCTS = 24;
